/**
 * Verify the screen has a portrait aspect ratio or a height of at least 600px
 * @returns {!boolean} `true` if the orientation is okay, `false` if not
 */
export default function checkOrientation() {
  // Some iOS/Safari versions still do not support orientation angle so we rely on `okayHeight`
  const angle = window.screen?.orientation?.angle ?? 90;
  const okayAngle = angle !== 90 && angle !== 270;
  // Check if the device is taller than it is wide or tablet sized
  const okayHeight = window.innerHeight > window.innerWidth || window.innerHeight > 600;
  return okayAngle || okayHeight;
}
